import {
  createFilterDTOSchema,
  createPageQueryDTOSchema,
  DEFAULT_PAGE_LIMIT,
  timestampDTOSchema,
} from '@tempo-io/common-dto';
import { z } from 'zod';
import { roleSchema } from './user-dto';

export const internalMembershipDTOSchema = z.object({
  id: z.number(),
  userId: z.string().nonempty(),
  organizationId: z.string().nonempty(),
  role: roleSchema,
  ...timestampDTOSchema.shape,
});

const internalMembershipSearchSortableFields = ['id', 'createdAt', 'updatedAt'] as const;

export const { filterSchema: internalMembershipSearchFilterSchema } = createFilterDTOSchema({
  userId: 'string',
  organizationId: 'string',
  createdAt: 'date',
  updatedAt: 'date',
});

export const internalMembershipSearchInputDTOSchema = z
  .object({
    filter: internalMembershipSearchFilterSchema,
    ...createPageQueryDTOSchema({
      sortableFields: internalMembershipSearchSortableFields,
      defaultSortBy: 'createdAt',
    }).shape,
  })
  .optional()
  .default({ sortOrder: 'asc', sortBy: 'createdAt', limit: DEFAULT_PAGE_LIMIT });
